import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles(() => ({
  openButton: { position: 'fixed', bottom: 85, left: 10, zIndex: 1000, width: 50, height: 35, padding: 0 },
  jsonContainer: { height: '50vh', overflow: 'auto' }
}));
